import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import PaymentOptions from "./component";
import UnlinkPluxeeModal from "./UnlinkPluxeeModal";
import { toast } from "react-toastify";
import DpHistory from "../DpHistory/component";
import { API_BASE_URL } from "../../config";
import NoInternet from "../../NoInterNet/component";

const PaymentOptionContainer=()=>{
      const navigate = useNavigate();
  const location = useLocation();
  const { makeApiRequest } = useApiRequest();
   const [sodexoUnlinkModal,setSodexoUnlinkModal]=useState(false)
 const [loader,setLoader]=useState(false)
  const searchParams = new URLSearchParams(location.search);
  const machineId = searchParams.get("machineId");
  const route = searchParams.get("route");
  const uuid = searchParams.get("value");
  // ✅ Offline state — drives the NoInternet screen
  const [noInternet, setNoInternet] = useState(false);


const [paymentOptionsList,setPaymentOptionsList]=useState([])


    useEffect(()=>{
 
fetchPaymentOption()
checkSodexoLink()

    },[])



      const handleNetworkError = (error) => {
    if (error.code === "ERR_NETWORK" || !error.response) {
      setNoInternet(true);
      setLoader(false);
      return true;
    }
    return false;
  };


    
        // ─── Online / offline listeners ───────────────────────────────────────────

  useEffect(() => {
    if (!navigator.onLine) {
      setNoInternet(true);
      setLoader(false);
    }

    const goOffline = () => setNoInternet(true);
    const goOnline = () => {
      setNoInternet(false);
      //setLoader(true);
      fetchPaymentOption()
checkSodexoLink()

    };

    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);




const checkSodexoLink = () => {
  const SodexoRequestId = localStorage.getItem("SodexoRequestId");
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");

  if (!SodexoRequestId) return;

  makeApiRequest({
   
    url: `${API_BASE_URL}/payment/api/v2/sodexo/check/link/${SodexoRequestId}`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": localStorage.getItem("uuid"),
    },

    handleSuccess: (res) => {
      // ✅ success response
      handleResponseCheckSodexo(res);
    },

    handleError: (err) => {
      // ❌ error response
      handleErrorCheckSodexo(err);
    },
  });
};


const handleErrorUnLinkLinkSodexo=()=>{

}




const handleErrorCheckSodexo=()=>{

}

const handleResponseCheckSodexo=()=>{
  localStorage.removeItem("SodexoRequestId")
  paymentOptionsList()
}


const fetchPaymentOption = (preCardVmID) => {
  setLoader(true)
  const machineId = localStorage.getItem("machineId");
  //if (!machineId) return; // Guard condition

  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");


const url =
  route == "mycart"
    ? `${API_BASE_URL}/consumerbe/api/v2/payment/option?machineId=${machineId}&balancePgArr=PAYTM%7CWALLET_LOYALTY%7CWALLET`
    : `${API_BASE_URL}/consumerbe/api/v2/payment/option?balancePgArr=PAYTM%7CWALLET_LOYALTY%7CWALLET`;
  makeApiRequest({
    url,
    method: "GET",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": deviceId,
    },
    request: {
      machineId: machineId,
    },
    handleSuccess: (res) => {
        //console.log("payment option list",res)
        setPaymentOptionsList(res.data.data)
        setLoader(false)
     
    },
    handleError: (err) => {
    
console.log("payment option list error",err.code=="ERR_NETWORK")
if(err.code=="ERR_NETWORK"){
return <NoInternet />

}
else{
      const uuid = deviceId;
      if (machineId && uuid) {
        navigate(`/login?machineId=${machineId}&vale=${uuid}`);
      }
    }
    },
  });
};




const LinkSodexo= () => {
 //console.log( "LinkSodexo-----------",);

  const SodexoRequestId = localStorage.getItem('SodexoRequestId');
  const UserJWTAuth = localStorage.getItem('UserJWTAuth');

  





  makeApiRequest({
    
    url: `${API_BASE_URL}/payment/api/v2/sodexo/link`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": localStorage.getItem("uuid"),
    },

    handleSuccess: (res) => {
      //console.log("✅ LinkSodexo", res.data.data.orderId);
      handleResponseLinkSodexo(res);
    },
    handleError: (err) => {
      //console.error("❌ Create Order Failed:", err);
      handleErrorSodexoLink(err);
      setLoader(false)
    },
  });

  
}

const handleErrorSodexoLink=()=>{

}

const handleResponseLinkSodexo=(res)=>{
  //console.log("Get response SodexoLink",res.data.data.redirectUrl.requestId);
        
  localStorage.setItem("SodexoRequestId",res.data.data.requestId)
  
  window.open(res.data.data.redirectUrl,"_self")
}


const handleResponseUnLinkLinkSodexo=(res)=>{
  setSodexoUnlinkModal(false)
  paymentOptionsList()
        
  
}

const UnLinkLinkSodexo= () => {


  const SodexoRequestId = localStorage.getItem('SodexoRequestId');
  const UserJWTAuth = localStorage.getItem('UserJWTAuth');

  



 makeApiRequest({

    url: `${API_BASE_URL}/payment/api/v2/sodexo/unlink`,
   method: "DELETE",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": localStorage.getItem("uuid"),
    },

    handleSuccess: (res) => {
      //console.log("✅ Order Created Successfully:", res.data.data.orderId);
      handleResponseUnLinkLinkSodexo(res);
    },
    handleError: (err) => {
      //console.error("❌ Create Order Failed:", err);
      handleErrorUnLinkLinkSodexo(err);
      setLoader(false)
    },
  });



}

const SetpaymentGatewayId23=()=>{

}

const SetpaymentGatewayId=(e,pgId,pgname,Name)=>{
    toast.success("Default Payment Method Set");
//console.log("SetpaymentGatewayId",pgId)
  //console.log("SetpaymentGatewayId  name",pgId,pgname,Name)
 localStorage.setItem("defaultPgId",pgId);
 if(pgname=="WALLET"){
  localStorage.setItem("defaultPgName",pgname);
   localStorage.setItem("defaultPgId",pgId);
  ///setDefaultPgName(pgname)
 }
 if(Name=="WALLET_LOYALTY"){
   localStorage.setItem("defaultPgName",pgname);
      localStorage.setItem("defaultPgId",pgId);
   //setDefaultPgName(pgname)
  }
  if(Name=="PAYTM_UPI"){
    localStorage.setItem("defaultPgName",pgname);
       localStorage.setItem("defaultPgId",pgId);

    //setDefaultPgName(pgname)
   }
 
  if(Name=="SODEXO"){
    localStorage.setItem("defaultPgName",pgname);
       localStorage.setItem("defaultPgId",pgId);
    //setDefaultPgName(pgname)
   }
  
   if(Name=="R_WALLET"){
    localStorage.setItem("defaultPgName","R_WALLET");
       localStorage.setItem("defaultPgId",pgId);
    //setDefaultPgName("R_WALLET")
   }
   if(Name=="R_CARD"){
    localStorage.setItem("defaultPgName","R_CARD");
       localStorage.setItem("defaultPgId",pgId);
    //setDefaultPgName("R_CARD")
   }
   if(Name=="R_UPI"){
    //console.log(" SetpaymentGatewayId hello")
    localStorage.setItem("defaultPgName","R_UPI");
    localStorage.setItem("defaultPgId",pgId);
    //setDefaultPgName("R_UPI")
   }

   
 //localStorage.setItem("defaultPgName",pgname);
console.log("route--->",route)
if(route=="dphistory"){
localStorage.setItem("default_Recharge_PgName",localStorage.getItem("defaultPgName"))
localStorage.setItem("default_Recharge_PgId",localStorage.getItem("defaultPgId"))
}
console.log("route--->",route)
if(route){
const parts = route?.split("/").filter(Boolean);

const r = parts[0]; // "taghistory"
const id = parts[1];    // "0035968753"

console.log("----------",r, id);
if(r=="taghistory"){
  navigate(`/taghistory/${id}`)

}
else{
  navigate(`/${route}`,{ replace: true })
}
}
 
}

  // ─── No internet — render NoInternet screen ───────────────────────────────────

  if (noInternet) return <NoInternet />;

return(<>
<UnlinkPluxeeModal open={sodexoUnlinkModal} onClose={setSodexoUnlinkModal} onConfirm={UnLinkLinkSodexo}/>
<PaymentOptions paymentOptionsList={paymentOptionsList} SetpaymentGatewayId={SetpaymentGatewayId} LinkSodexo={LinkSodexo} loader={loader} setSodexoUnlinkModal={setSodexoUnlinkModal}/>
</>)

}
export default PaymentOptionContainer